import { render, staticRenderFns } from "./ModalDepartment.vue?vue&type=template&id=65f34fc3&scoped=true"
import script from "./ModalDepartment.vue?vue&type=script&lang=js"
export * from "./ModalDepartment.vue?vue&type=script&lang=js"
import style0 from "./ModalDepartment.vue?vue&type=style&index=0&id=65f34fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f34fc3",
  null
  
)

export default component.exports